import {Component, OnInit, ViewChild} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {MatTableDataSource} from '@angular/material/table';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {DispatchPendingModel} from '../../shared/dto/dispatch-pending.model';
import {ApprovalService} from '../../service/approval.service';
import {TokenStorageService} from '../../shared/service/token-storage.service';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-card-dispatch',
  templateUrl: './card-dispatch.component.html',
  styleUrls: ['./card-dispatch.component.scss']
})
export class CardDispatchComponent implements OnInit {
  public dispatchForm: FormGroup;
  manual:boolean = true;
  public userName: string;
  public type: string;
  public scanPendingList: DispatchPendingModel[];
  scanPending: DispatchPendingModel = new DispatchPendingModel();
  displayedColumns: string[] = ['appRefNo', 'sidNo', 'nic', 'name', 'cdc' ,'stage','type', 'createdDate', 'action'];
  dataSource: MatTableDataSource<any>;

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  constructor(private approvalService: ApprovalService,private tokenStorageService: TokenStorageService,
              private route: ActivatedRoute) {
    this.userName=this.tokenStorageService.getUserObjectToken().username;
    this.route.paramMap.subscribe(params => {
      this.type = params.get('type');
    });
  }

  ngOnInit() {
    this.dispatchForm = new FormGroup({
      dispatchType: new FormControl(0),
      sidNo: new FormControl(null),
      name: new FormControl(null),
      nic: new FormControl(null),
      cdcNo: new FormControl(null),
      SID: new FormControl(null),
    });
    this.onSearch();
  }

  loadPreivew() {
    if(this.dispatchForm.value.dispatchType == 0) {
      this.onSearch();
      this.manual=true;
    } else {
      this.manual=false;
    }
  }

  onSearch() {
    this.scanPending.appRefNo = this.dispatchForm.value.sidNo;
    this.scanPending.sidNo = this.dispatchForm.value.SID;
    this.scanPending.cdcNo = this.dispatchForm.value.cdcNo;
    this.scanPending.name = this.dispatchForm.value.name;
    this.scanPending.nic = this.dispatchForm.value.nic;
    this.scanPending.loginUser = this.userName;
    this.scanPending.type = this.type;

    this.approvalService.searchDispatchPendingData(this.scanPending).subscribe(
      (result: any ) => {
        this.scanPendingList = result;
        this.dataSource = new MatTableDataSource(this.scanPendingList);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
    );
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  setBase64(code: string): string {
    return btoa(code);
  }

  onReset() {
    this.dispatchForm.reset({
      sidNo: null,
      name: null,
      nic: null,
      cdcNo: null,
    });
    this.getAllRequestDetails();
  }

  getAllRequestDetails(){
    this.scanPending.appRefNo = this.dispatchForm.value.sidNo;
    this.scanPending.cdcNo = this.dispatchForm.value.cdcNo;
    this.scanPending.name = this.dispatchForm.value.name;
    this.scanPending.nic = this.dispatchForm.value.nic;
    this.scanPending.loginUser = this.userName;
    this.scanPending.type = this.type;

    this.approvalService.searchDispatchPendingData(this.scanPending).subscribe(
      (result: any ) => {
        this.scanPendingList = result;
        this.dataSource = new MatTableDataSource(this.scanPendingList);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
    );
  }

}
